import React, { Component } from 'react';

import Typography from '@material-ui/core/Typography';
import {materialThemeField, themeColorText} from '../App'
import { ThemeProvider } from "@material-ui/styles";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Label from '../Elements/Label/labels';
import './about.css'
import './aboutAdaptive.css'
import i18next from 'i18next'

const baseUrl = process.env.PUBLIC_URL;
class ClientInfo extends Component {
    constructor(props)
    {
        super(props)
        this.state = {
        }
    }
    componentDidMount()
    {
        this.props.setSelectedIndex(6)
    }
    render() {
        var tr = {    
            InfoOfProduct: i18next.t('About.InfoOfProduct'),
            nameProduct: i18next.t('About.nameProduct'),
            version: i18next.t('About.version'),
            developer: i18next.t('About.developer'),
            company: i18next.t('About.company')
        }
        const {theme} = this.props;
        return(
            <div className="containers">
                <ThemeProvider theme={materialThemeField}>
                    <Grid container justify="center" spacing={3}>
                        <Grid item xs={"auto"}>
                            <Paper className="clientinfoBox">
                                <Label style={{color: themeColorText.color}} textLabel={tr.InfoOfProduct} className="clientinfoLabel"></Label> 
                                <div style={{paddingTop: 20, paddingBottom: 20}}>
                                {theme === "light" &&
                                  <img alt="...loading..." style={{maxWidth: 300}} src={baseUrl + "/images/loyalty_logo_light_main.png"}></img>
                                }
                                {theme === "dark" &&
                                  <img alt="...loading..." style={{maxWidth: 300}} src={baseUrl + "/images/loyalty_logo_dark_main.png"}></img>
                                }
                                </div>
                                <Typography className="TypographyLabel" variant="h6" >{tr.nameProduct}</Typography>
                                <br></br>       
                                <Typography className="TypographyLabel" variant="h6" >{tr.version}</Typography>
                                <br></br>  
                                <Typography className="TypographyLabel" variant="h6" >{tr.developer}</Typography>
                                <br></br>  
                                <Typography className="TypographyLabel" variant="h6" >{tr.company}</Typography>
                                <br></br>  
                            </Paper>
                        </Grid>
                    </Grid>
                </ThemeProvider>
            </div>
        );

    }
}
export default ClientInfo;

